import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LoadingSpinner } from 'edenred-ui';

import { isSignupTokenValidRequest } from '@epi-api/signUp';
import { showNotification } from '@epi-actions/overlays';
import { isReCaptchaLoadedSelector } from '@epi-selectors/reCaptchaSelectors';

import {
  CreateAccountForm,
  ContractCompleted,
  TokenExpired,
  TokenInvalid,
  TokenValidationFailed
} from './components';
import { SignupTokenErrors } from '@epi-constants/signupTokenErrors';
import { ContactDeleted } from './components/ContactDeleted';
import EmailToConfirm from '@epi-pages/EmailToConfirm';

function CreateAccount({ location, dispatch, isReCaptchaLoaded }) {
  const [tokenValidityState, setTokenValidityState] = useState({
    isValid: false,
    errorCode: null,
    username: null
  });

  const params = new URLSearchParams(location.search);
  const signToken = params.get('token');
  const contactRegistrationType = params.get('type');

  async function fetchIsSignUpTokenValid() {
    try {
      const tokenValidity = await isSignupTokenValidRequest(
        signToken,
        contactRegistrationType
      );
      setTokenValidityState(tokenValidity);
    } catch (e) {
      dispatch(showNotification({ message: 'messages.error' }, 'error'));
      setTokenValidityState({
        isValid: false,
        errorCode: SignupTokenErrors.ValidationFailed,
        username: null
      });
    }
  }

  useEffect(() => {
    if (isReCaptchaLoaded) {
      fetchIsSignUpTokenValid();
    }
  }, [isReCaptchaLoaded]);

  function render() {
    if (tokenValidityState.isValid) {
      return <CreateAccountForm />;
    }
    switch (tokenValidityState.errorCode) {
      case SignupTokenErrors.IncorrectToken:
        return <TokenInvalid />;
      case SignupTokenErrors.EmailAddressIsNotVerified:
        return (
          <EmailToConfirm
            isAccountExist={true}
            username={tokenValidityState.username}
          />
        );
      case SignupTokenErrors.CreationCompleted:
        return <ContractCompleted />;
      case SignupTokenErrors.ExpiredToken:
        return <TokenExpired />;
      case SignupTokenErrors.ContactDeleted:
        return <ContactDeleted />;
      case SignupTokenErrors.ValidationFailed:
        return <TokenValidationFailed />;
    }
    return <LoadingSpinner />;
  }

  return render();
}

CreateAccount.propTypes = {
  location: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  isReCaptchaLoaded: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  isReCaptchaLoaded: isReCaptchaLoadedSelector(state)
});

export default connect(mapStateToProps)(CreateAccount);
